import router from '@/router';
import {
  clDntsList,
  getNumerationFile,
  releaseNumerationFile,
  updateSubjectsFile
} from '@/febos/servicios/api/dnt.api';
import {
  clTraysListV2,
  fileSignaturePerson,
  signFileByPerson,
  fileSignatureExternal,
  getInfoCUExternal,
  sendToFlowMassive,
  requestOtpForSignature
} from '@/febos/servicios/api/v2.aprobaciones.api';
import {
  // clTraysList,
  getAttachments,
  fileFlowDetails,
  cancelFile,
  commentFlow,
  processFlow,
  signFlow,
  signFlowMassive,
  manageFlow,
  sendToFlowFile,
  clApprovalsDashboard,
  disparageFile,
  listApprovals,
  createApprovalsTemplate,
  getApprovalTemplate,
  deleteApprovalTemplate
} from '@/febos/servicios/api/aprobaciones.api';
import { ioEDFilesGet } from '@/febos/servicios/api/repositories.api';
import { signAttachment } from '@/febos/servicios/api/documents.api';
import { fileBinnacle } from '@/febos/servicios/api/portafolio.api';
import store from '@/store/store';
import { listOptions, listV2Options } from '@/febos/servicios/api/opciones.api';

export const fetchDocumentTypeReferences = async ({ commit, state }) => {
  if (state.documentTypeReferences.length) return;
  const { data } = await listOptions({
    grupoOpcion: 'tipos-referencias-documentos',
    deshabilitado: 'no'
  });
  commit('SET_DOCUMENT_TYPE_REFERENCES', data.opciones);
};
import {
  ioDownloadPrivateFile,
  ioListOptions,
  ioMassiveProcess
} from '@/febos/servicios/api/herramientas.api';
import { app } from '@/main';
import { searchTrays } from '@/febos/servicios/api/busqueda.api';

export const listDocuments = async ({ commit }, { data }) => {
  try {
    commit('SET_DNT_LIST', []);
    commit('SET_LOADING', true);
    const response = await clDntsList(data);
    commit('SET_DNT_LIST', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const listTrays = async ({ commit }, query) => {
  try {
    commit('SET_TRAY', []);
    commit('SET_LOADING', true);
    const response = await clTraysListV2(query);
    commit('SET_TRAY', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const searchInTrays = async ({ commit }, query) => {
  try {
    commit('SET_TRAY_SEARCH', []);
    commit('SET_LOADING', true);
    const response = await searchTrays(query);
    commit('SET_TRAY_SEARCH', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const downloadTrays = async ({ commit }, query) => {
  try {
    commit('SET_LOADING', true);
    const response = await clTraysListV2(query);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const markFlows = ({ commit }, selected) => {
  commit('UPDATE_SELECTED_FLOWS', selected);
};

export const markFlow = ({ commit }, { id, selected }) => {
  commit('UPDATE_SELECTED_FLOW', { id, selected });
};

export const getAttachmentFiles = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_ATTACHMENTS', true);
    commit('SET_ATTACHMENTS', []);
    const response = await getAttachments(payload);
    commit('SET_ATTACHMENTS', response.data.previsualizaciones);
    return response;
  } finally {
    commit('SET_LOADING_ATTACHMENTS', false);
  }
};

export const getApprovalFileDetails = async ({ commit }, payload) => {
  try {
    commit('SET_PROCESS_DOCUMENT', '');
    commit('SET_LOADING', true);
    commit('SET_FILE_ON_FLOW', {
      detalle: {}
    });
    const response = await fileFlowDetails(payload);
    commit('SET_FILE_ON_FLOW', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getApprovalDashboardFlow = async ({ commit }, payload) => {
  try {
    commit('SET_FLOW_DASHBOARD_LOADING', true);
    commit('SET_FLOW_DASHBOARD', {});
    const response = await fileFlowDetails(payload);
    commit('SET_FLOW_DASHBOARD', response.data);
    return response;
  } finally {
    commit('SET_FLOW_DASHBOARD_LOADING', false);
  }
};

export const getCsvApprovalsDashboard = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await clApprovalsDashboard(payload);
    window.open(response.data.csvFile, '_blank');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getApprovalManagedFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await getAttachments(payload);
    window.open(response.data.previsualizaciones[0].url, '_blank');
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const attemptCancelFile = async ({ commit }, { cancel, idAprobacion }) => {
  try {
    commit('SET_LOADING', true);
    const response = await cancelFile(cancel);
    await commit('UPDATE_CANCELED_FILE', idAprobacion);
    store.commit('Modals/CLOSE_MODAL');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const attemptDisparageFlow = async ({ commit }, file) => {
  try {
    commit('SET_LOADING', true);
    const response = await disparageFile(file);
    await commit('UPDATE_DISPARAGE_FILE', file.ejecucionId);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getFileBinnacle = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_BINNACLE', true);
    commit('SET_BINNACLE', {});
    const response = await fileBinnacle(payload);
    commit('SET_BINNACLE', response.data.bitacora);
    return response.data;
  } finally {
    commit('SET_LOADING_BINNACLE', false);
  }
};

export const commentFileFlow = async ({ commit }, { request, body }) => {
  try {
    commit('SET_LOADING', true);
    const response = await commentFlow(request, body);
    commit('UPDATE_FILE_ON_FLOW', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const updateSubjectsOnFile = async ({ commit }, { fileId, subjects }) => {
  try {
    commit('SET_LOADING', true);
    const response = await updateSubjectsFile(fileId, subjects);
    store.commit('Dnts/UPDATE_SUBJECTS_FILE', response.data.destinatarios);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const processFileFlow = async ({ commit }, { request, body }) => {
  try {
    commit('SET_LOADING', true);
    const response = await processFlow(request, body);
    router.back();
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const processMassiveFiles = async ({ commit }, { body }) => {
  try {
    commit('SET_LOADING', true);
    const response = await ioMassiveProcess(body);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const signMassiveFiles = async ({ commit }, body) => {
  try {
    commit('SET_LOADING', true);
    const response = await signFlowMassive(body);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const assignFileFlow = async ({ commit }, { request, body }) => {
  try {
    commit('SET_LOADING', true);
    const response = await processFlow(request, body);
    router.go(0);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const signFileFlow = async ({ commit }, body) => {
  try {
    commit('SET_LOADING', true);
    const response = await signFlow(body);
    if (!body.noRedirectOnEnd) {
      router.back();
    }
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const signAttachmentFlow = async ({ commit }, body) => {
  try {
    commit('SET_LOADING', true);
    const response = await signAttachment(body);
    if (!body.noRedirectOnEnd) {
      if (response.data.adjuntoUrlS3Firmado) {
        window.open(response.data.adjuntoUrlS3Firmado, '_blank');
      }
      router.go();
    }
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const manageFileFlow = async ({ commit }, { body, meta }) => {
  try {
    commit('SET_LOADING', true);
    const response = await manageFlow(body, meta);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const selectFileState = ({ commit }, file) => {
  commit('SET_SELECTED_FILE', file);
};

export const setProcessDocument = ({ commit }, processType) => {
  commit('SET_PROCESS_DOCUMENT', processType);
};

export const updateRetainFile = ({ commit }, { id }) => {
  commit('UPDATE_RETAIN_FILE', id);
};

export const searchNumeration = async ({ commit }, { document, group }) => {
  try {
    commit('SET_NUMERATION_DNT', '');
    commit('SET_LOADING_NUMERATION', true);
    const response = await getNumerationFile(document, group);
    commit('SET_NUMERATION_DNT', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING_NUMERATION', false);
  }
};

export const releaseNumeration = async ({ commit }, configurationId) => {
  try {
    commit('SET_NUMERATION_DNT', '');
    commit('SET_LOADING_NUMERATION', true);
    const response = await releaseNumerationFile(configurationId);
    commit('SET_NUMERATION_DNT', '');
    return response.data;
  } finally {
    commit('SET_LOADING_NUMERATION', false);
  }
};

export const sendToFlow = async ({ commit }, { data }) => {
  try {
    commit('SET_LOADING', true);
    const payload = {
      params: {
        aprobacionId: data.aprobacionId || 0,
        temporal: true,
        privado: data.ejecucion.privado
      },
      body: data
    };
    const response = await sendToFlowFile(payload);
    await router.push({
      path: '/aprobaciones/entrada'
    });
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const sendNewFileFlow = async ({ commit }, { data }) => {
  try {
    commit('SET_LOADING', true);
    const payload = {
      params: {
        aprobacionId: data.aprobacionId || 0,
        temporal: true,
        privado: data.ejecucion.privado,
        ...(data.origen && { origen: data.origen })
      },
      body: data
    };
    const response = await sendToFlowFile(payload);
    if (data.origen && data.origen === 'respuesta') {
      router.back();
    } else {
      await router.go(0);
    }
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const sentToFlowRepository = async ({ commit }, { data }) => {
  try {
    commit('SET_LOADING', true);
    const payload = {
      params: {
        aprobacionId: data.aprobacionId || 0,
        temporal: true,
        privado: 'N'
      },
      body: data
    };
    const response = await sendToFlowFile(payload);
    await router.go(-1);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const sendToFlowRepositoryMassive = async ({ commit }, { data }) => {
  try {
    commit('SET_LOADING', true);
    const payload = {
      params: {
        temporal: true,
        privado: 'N'
      },
      body: {
        ...data,
        aprobacionId: data.aprobacionId || 0,
      }
    };
    const response = await sendToFlowMassive(payload);
    await router.go(-1);
    app.$bvToast.toast(
      '¡Operación efectuada correctamente! Se te avisará por correo cuando termine el proceso completo.',
      {
        title: '¡Genial!',
        variant: 'primary',
        pauseOnHover: true,
        solid: true,
        autoHideDelay: 8000
      }
    );
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const clearWizardData = ({ commit }) => {
  commit('CLEAR_WIZARD_DATA');
};

export const addWizardData = ({ commit }, payload) => {
  commit('ADD_WIZARD_DATA', payload);
};

export const mergeWizardData = ({ commit }, payload) => {
  commit('MERGE_WIZARD_DATA', payload);
};

export const loadWizardFileRepo = async ({ commit }, { id, mapper }) => {
  try {
    commit('SET_LOADING', true);
    const { data } = await ioEDFilesGet({
      repositoryId: 0,
      fileId: id
    });
    commit('SET_WIZARD_DATA', mapper(data.archivo));
    const file = await ioDownloadPrivateFile({
      path: data.archivo.adjuntoUrl,
      nombre: data.archivo.nombre,
      descargable: true
    });
    commit('SET_WIZARD_DATA', mapper({
      ...data.archivo,
      adjuntoUrl: file.data.url
    }));
    commit('UPDATE_WIZARD_DATA', file.data.url);
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getApprovalsDashboard = async ({ commit }, params) => {
  try {
    commit('SET_APPROVALS_DASHBOARD', { lista: [], resumen: {} });
    commit('SET_LOADING', true);
    const response = await clApprovalsDashboard(params);
    commit('SET_APPROVALS_DASHBOARD', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getReferenceApprovals = async ({ commit }) => {
  const response = await listOptions({
    grupoOpcion: 'aprobaciones_referencias',
    deshabilitado: 'no'
  });
  commit('SET_REFERENCE_APPROVALS', response.data.opciones);
};

export const getPurchaseType = async ({ commit }) => {
  const response = await listOptions({
    grupoOpcion: 'tipos.compra',
    deshabilitado: 'no'
  });
  commit('SET_PURCHASE_TYPE', response.data.opciones);
};

export const getApprovalsTemplates = async ({ commit }, payload) => {
  commit('SET_PAGINATION_DATA', null);
  try {
    commit('SET_LOADING', true);
    commit('SET_APPROVALS', []);
    commit('SET_PAGINATION_DATA', null);
    const response = await listApprovals(payload);
    commit('SET_APPROVALS', response.data.aprobaciones);
    commit('SET_PAGINATION_DATA', response.data);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getApprovalsTemplatesCsv = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);

    const response = await listApprovals(payload);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const addApprovalTemplate = async (_, payload) => {
  await createApprovalsTemplate(payload);
};

export const editApprovalTemplate = async (_, payload) => {
  await createApprovalsTemplate(payload);
};

export const fetchApprovalTemplate = async ({ commit }, payload) => {
  commit('SET_APPROVAL_TEMPLATE', {});
  const response = await getApprovalTemplate(payload);
  commit('SET_APPROVAL_TEMPLATE', response.data.aprobacion);
};

export const removeApprovalTemplate = async (_, payload) => {
  await deleteApprovalTemplate(payload);
};

export const getSelectsOptions = async ({ commit }, { groupOption, filters, option }) => {
  const response = await listV2Options({
    grupoOpcion: groupOption,
    filtros: filters || ''
  });
  if (option === 'category') commit('SET_CATEGORIES', response.data.opciones);
  if (option === 'document') commit('SET_DOCUMENTS', response.data.opciones);
  if (option === 'purchaseType') commit('SET_PURCHASE_TYPES', response.data.opciones);
  if (option === 'reportType') commit('SET_REPORT_TYPES', response.data.opciones);
};

export const getConsequencesOptions = async ({ commit }) => {
  const response = await listOptions({
    grupoOpcion: 'aprobaciones_desencadenadores',
    deshabilitado: ''
  });
  commit('SET_CONSEQUENCES', response.data.opciones);
};

export const getStepTypes = async ({ commit }) => {
  const response = await ioListOptions({
    grupoOpcion: 'aprobaciones_tipos_pasos',
    filtros: 'deshabilitado:0',
    orden: '+valor'
  });
  const { opciones } = response.data;
  commit('SET_STEP_TYPES', opciones.map((item) => ({
    ...JSON.parse(item.extra || '{}'),
    ...item,
    valor: +item.valor,
  })));
};
export const getStepRoles = async ({ commit }) => {
  const response = await ioListOptions({
    grupoOpcion: 'aprobaciones_tipos_roles',
    filtros: 'deshabilitado:0',
    orden: '+valor'
  });
  const { opciones } = response.data;
  commit('SET_STEP_ROLES', opciones.map((item) => ({
    ...JSON.parse(item.extra || '{}'),
    ...item,
    valor: +item.valor,
  })));
};

export const removeSignaturesDropped = ({ commit }) => {
  commit('REMOVE_SIGNATURES_DROPPED');
};

export const getApprovalFileSignaturePerson = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    commit('SET_FILE_ON_FLOW', {
      detalle: {}
    });
    const response = await fileSignaturePerson(payload);
    commit('SET_FILE_ON_FLOW', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getApprovalFileSignatureExternal = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    commit('SET_FILE_ON_FLOW', {
      detalle: {}
    });
    const response = await fileSignatureExternal(payload);
    commit('SET_FILE_ON_FLOW', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getCUInfo = async ({ commit }, {
  processId, action, domain, token
}) => {
  try {
    commit('SET_LOADING', true);
    commit('SET_INFO_CU', {});
    const response = await getInfoCUExternal({
      processId, action, domain, token
    });
    commit('SET_INFO_CU', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const singPersonFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await signFileByPerson(payload);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

// TODO: Reemplazar con el endpoint real cuando se tenga la info del API
export const requestSignatureOtp = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await requestOtpForSignature(payload);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};
